<div class="datetime-field-class date-pick">
  <mat-form-field>
    <input matInput [disabled]="disabled" [min]="minDate" [max]="maxDate" [(ngModel)]="value" name="dateTo"
           (focus)="pickerFrom.open()" (click)="pickerFrom.open()"
           [matDatepicker]="pickerFrom"
           placeholder="Choose a date">
    <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
    <mat-datepicker #pickerFrom></mat-datepicker>
  </mat-form-field>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/fields/date-select-field/date-select-field.component.html